import BreezeIcon from "../assets/images/General/BreezeIcon.png";
import JmmIcon from "../assets/images/General/JmmIcon1.png";
import JtaIcon from "../assets/images/General/JtaIcon.png";
import FmcAdminIcon from "../assets/images/General/FmcAdminIcon.png";
import RafaIcon from "../assets/images/General/RafaIcon.png";
import IraIcon from "../assets/images/General/iraIcon.png";
import AmmIcon from "../assets/images/General/ammIcon.png";
import constants from "./constants";
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';

const ReleasedApplications = [
  //=============================================================== >>>>> List Of Applications...
  {
    appTag: "Breeze",
    appShortTag: "BREEZE",
    appIcon: BreezeIcon,
    appCategory: "public",
    appUrl: `${constants.domain}breeze/app/`,
    isOpenNewTab: true,
  },
  {
    appTag: "Report-A-Fault",
    appShortTag: "RAFA",
    appIcon: RafaIcon,
    appCategory: "public",
    appUrl: `${constants.domain}rafa/app/`,
    appDescription: "Report-A-Fault",
    isOpenNewTab: true,
  },
  {
    index: 1,
    appTag: "Job Management",
    appShortTag: "JMM",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "jmm",
    appUrl: `${constants.domain}jmm/app/`,
    appDescription:
      "Job Management Module, view and manage jobs and FM contact info.",
  },
  {
    index: 2,
    appTag: "Asset Management Module",
    appShortTag: "AMM",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "amm",
    appUrl: `${constants.domain}amm/app/dashboard/search/`,
    appDescription:
      "Asset Management Module, view and manage estates, properties, buildings and assets.",
  },

  {
    index: 4, 
    appTag: "Job Ticketing",
    appShortTag: "JTA",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "jta",
    appUrl: `${constants.domain}jta/app/`,
    appDescription: "Job Ticketing, create job tickets.",
  },
  {
    index: 7,
    appTag: "FMC Admin",
    appShortTag: "FMC ADMIN",
    appIcon: FmcAdminIcon,
    appCategory: "private",
    appRequiredClaim: "fmc",
    appUrl: `${constants.domain}fmcadmin/`,
  },
  {
    index: 5,
    appTag: "Incident Reporting",
    appShortTag: "IRA",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "ira",
    appUrl: `${constants.domain}ira/app/incidents/view/`,
    appDescription: "Incident Reporting, manage and log incident reports.",
  },
  {
    index: 6,
    appTag: "Lift Escalator Breakdown Form",
    appShortTag: "LEBF",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "kmm",
    appUrl: `${constants.domain}jmm/app/kmm/lbf`,
    appDescription: "Lift Escalator Breakdown Form, manage and report lift breakdowns.",
  },
  {
    index: 3,
    appTag: "Knowledge Management",
    appShortTag: "KMM",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "kmm",
    appUrl: `${constants.domain}jmm/app/kmm/ticket`,
    appDescription:
      "Knowledge Management Module, view and manage documents.",
  },
   {
    index: 8,
    appTag: "AskJess",
    appShortTag: "AskJess",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "aje",
    appUrl:  `${constants.domain_intranet}askjess/app`,
    appDescription: "AskJess, AI Chatbot",
    isOpenNewTab: true,
  }, {
    index: 9,
    appTag: "AskJess",
    appShortTag: "AskJess",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "asj", // for QA
    appUrl:  `${constants.domain_intranet}askjess/app`,
    appDescription: "AskJess, AI Chatbot",
    isOpenNewTab: true,
  }, 
  {
    index: 10,
    appTag: "Sustainability Reporting",
    appShortTag: "SR",
    appIcon: JtaIcon,
    appCategory: "private",
    appRequiredClaim: "sr", // for QA
    appUrl: `${constants.domain}sr/app/report-dashboard`,
    appDescription: "Sustainability Reporting, manage sustainability data for JTC properties.",
  }, 
];

export default Object.freeze(ReleasedApplications);
